import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import SwaggerPage from './SwaggerPage';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';

type Props = {};

const APIPage = (props: Props) => {
  const authData = useSelector((state: RootState) => state.auth);

  return authData.isPortalUser ? (
    <Box data-testid="Box-klzs" p={10} paddingX={10} alignItems="center">
      <Typography
        data-testid="Typography-usiu"
        variant="h6"
        sx={{
          textAlign: 'center',
          minWidth: '100%',
          pt: 1,
          paddingLeft: 1.5,
          paddingRight: 3,
          margin: 'auto',
          borderRadius: 1,
        }}
      >
        API Documentation
      </Typography>
      <Box
        data-testid="Box-k0n2"
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <SwaggerPage />
      </Box>
    </Box>
  ) : null;
};

export default APIPage;
